<template>
  <header class="container">
    <div class="c-logo">
      <img src="https://firebasestorage.googleapis.com/v0/b/rahal-7e911.appspot.com/o/public%2FlandingPage%2Frahal-logo.webp?alt=media&token=62ea1dfb-20b9-4541-aa4d-442d6e1e737c" alt="">
    </div>

   <div class="menu-container">
    <div @click="expandMenu" class="menu" :class="menuIsOpen ? 'menuOpened' : 'menuClosed'"> <img height="30" src="/menu.svg" alt=""></div>
  
    <nav   :class="menuIsOpen ? 'opened' : 'closed'">
      <ul>
        <li @click="closeMenu">
          <a href="#home">{{
            $t('saryahLanding.header.home')
          }}</a>
        </li>
        <li @click="closeMenu">
          <a href="#about">{{
            $t('saryahLanding.header.aboutUs')
          }}</a>
        </li>
        <li @click="closeMenu">
          <a href="#services">
            {{ $t('saryahLanding.header.Services') }}</a
          >
        </li>
        <li @click="closeMenu">
          <a href="#contact">{{
            $t('saryahLanding.header.ContactUs')
          }}</a>
        </li>
        <app-i18n-flags class="flagMenu"></app-i18n-flags>
      </ul>
    </nav>
   </div>
   
    <!-- flags -->
    <app-i18n-flags class="flagNotMenu"></app-i18n-flags>
  </header>
</template>


<script>

export default {

  data() {
    return {
      menuIsOpen:false
    };
  },

  computed: {
    isRTL() {
      return this.currentLanguageCode == 'ar';
      // return localStorage.getItem('language') == 'ar'
    },
  },

  methods: {
    expandMenu() {
      this.menuIsOpen = !this.menuIsOpen;
      
      if (this.menuIsOpen) {
        document.body.classList.add("disableScroll");
      } else {
        document.body.classList.remove("disableScroll");
      }
    },

    closeMenu(){
      this.menuIsOpen =false
      document.body.classList.remove("disableScroll");
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
  
}
.c-logo img {
  font-size: 25px;
  font-weight: 600;
  height:55px;
  width:55px;
}
nav ul {
  display: flex;
  list-style: none;
  width: 100%;
  margin: 0px;
  gap: 20px;
}
nav ul li {
  font-size: 17px;
  font-weight: 600;
  padding: 20px 15px;
}
li:hover {
  background: #eeeeee6b;
}
a {
  all: unset !important;
}
.menu-container .menu{
  display:none;
  cursor:pointer;
  position:relative;
  z-index:99999;
  padding: 5px;
}
.flagMenu{
  display:none;

}
.flagMenu img{
  height: 30px !important;
}
@media (width < 768px){
  .menu-container .menu{
display:flex;
  }
  .menuOpened{
    background:#eee;
    border-radius:50%;

  }

  .menu-container nav{
    transform: translateX(-100%);
    position : fixed;
    z-index: 999;
    flex-direction :column;
    overflow: hidden;
    left:0;
    top: 0px;
    padding-top: 65px;
    width:100%;
    height: 100%;
    background: white;
    transition: all 0.5s ease;
  }
  .opened {
    transform: translateX(0px) !important;
  }

  .menu-container nav ul{
    flex-direction :column;
    width: 100%;
    left: 0px;
    position: absolute;
    padding:0px 20px;
    gap:0px;
    align-items: start;
  }

 nav ul li {
    padding: 15px 10px;
    font-size: 16px;
    font-weight: 600;
    width: 100%;
    border-bottom: 1px solid #bbbbbb;

}



  .flagMenu{
    display :flex;
margin-top: 20px;
margin:15px 10px;
  }

  .flagMenu ::v-deep img{
    height:30px
  }
  .flagNotMenu{
    display:none;
  }
}

</style>